import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { makeStyles } from '@material-ui/core/styles';

const logo = 'https://viBBes.art/wp-content/uploads/2020/06/logo-viBBes-side.png';
const link = 'https://viBBes.art';

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  appbar: {
    backgroundColor: '#333',
  },
  title: {
    flex: 1,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  toolbar: {
    maxHeight: 48,
    justifyContent: 'space-between',
  },
  spacer: {
    flex: 1,
  },
  logo: {
    maxWidth: '120px',
  },
  link: {
    color: '#FFF',
    marginRight: 10,
    fontSize: 14,
  },
});

const CustomAppBar = () => {
  const classes = useStyles();
  return (
    <AppBar color="secondary" className={classes.appbar}>
      <Toolbar className={classes.toolbar}>
        <img src={logo} alt="logo" className={classes.logo} />
        <a className={classes.link} href={link} target="_blank" rel="noopener noreferrer">
          Go Back to viBBes.Art
        </a>
      </Toolbar>
    </AppBar>
  );
};

export default CustomAppBar;
